export const environment = {
  production: true,
  buildId: '3584760192622801',
  configFile: 'config.json',
};
